<template>
    <div class="flex flex-col gap-2.5">
        <slot></slot>
        <div class="w-full flex items-center gap-0.5">
            <div v-for="(item, index) in steps" :key="`progress-item-${item}`" class="w-full h-1 " :class="{
                'bg-sky-500': item <= currentStep || props.completed,
                'animate-pulse': item === currentStep && !props.completed,
                'bg-sky-200': item > currentStep,
                'rounded-lg': index === 0 || index === steps.length
            }">
            </div>
        </div>
        <slot name="info" :countdownSeconds="countdownSeconds"></slot>
    </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { useTimeoutFn } from "@vueuse/core";

const props = defineProps({
    maxSteps: {
        type: Number,
        required: true,
    },
    startStep: {
        type: Number,
        default: 1,
    },
    stepDuration: {
        type: Number,
        default: 30
    },
    completed: {
        type: Boolean,
        default: false,
    }
});

const emit = defineEmits(['step', 'finish']);

const steps = ref(Array.from({ length: props.maxSteps }, (_, index) => index + 1));

const currentStep = ref(props.startStep);
const countdownSeconds = ref(props.stepDuration);

const { start, stop } = useTimeoutFn(() => {
    if (currentStep.value === props.maxSteps && countdownSeconds.value === 0) {
        emit('finish');
        stop();
        return;
    }

    countdownSeconds.value--;
    if (countdownSeconds.value === 0) {
        countdownSeconds.value = props.stepDuration;
        currentStep.value++
        emit('step');
    }
    start();
}, 1000);


watch([() => props.completed, () => props.startStep], ([completed, startStep]) => {
    if (completed) {
        stop();
    }

    currentStep.value = startStep;
}, { immediate: true })

</script>
